import React, { useState } from "react";
import { HelpCircle, ChevronDown, LifeBuoy, Mail, MessageSquare } from "lucide-react";

const FAQS = [
  {
    q: "Bagaimana cara ikut campaign?",
    a: "Buka tab Campaign, pilih campaign sesuai kategori & peran kamu, klik \"Ikuti Campaign\". Kamu akan diminta menghubungkan akun TikTok/Shopee sesuai platform campaign. Setelah itu produksi konten sesuai SOW lalu upload bukti post.",
  },
  {
    q: "Kenapa saat join saya diminta link TikTok / Shopee?",
    a: "Setiap campaign punya platform target. Dengan menghubungkan akun, tim Manager otomatis melihat akun kamu sudah terverifikasi untuk platform tersebut. Kamu juga mendapat bonus point untuk setiap channel yang terverifikasi.",
  },
  {
    q: "Bagaimana cara upload bukti post?",
    a: "Pada campaign yang sudah kamu ikuti, klik \"Upload Bukti Post\". Wajib menyertakan screenshot bukti + link post (TikTok/Shopee). Bukti akan diverifikasi Manager lalu final approval oleh CEO.",
  },
  {
    q: "Bagaimana sistem approval bekerja?",
    a: "Dua tahap: Manager melakukan approval pertama, lalu CEO/Secretariat memberikan final approval. Point konten kamu diberikan setelah final approval.",
  },
  {
    q: "Bagaimana cara mendapatkan point & naik tier?",
    a: "Kamu dapat point dari onboarding, verifikasi channel, konten yang di-approve, milestone, dan misi. Tier dihitung dari point valid dalam 180 hari terakhir. Menukar reward (redeem) TIDAK menurunkan tier kamu.",
  },
  {
    q: "Bagaimana menukar reward?",
    a: "Buka tab My Points → Reward Store. Pastikan saldo reward mencukupi, lalu tukar. Riwayat penukaran bisa dilihat di tab yang sama.",
  },
  {
    q: "Kapan saya diingatkan soal deadline?",
    a: "Kamu otomatis mendapat notifikasi (ikon lonceng) pada H-3 dan H-1 sebelum deadline campaign bila belum mengupload bukti post.",
  },
  {
    q: "Bagaimana melengkapi alamat pengiriman?",
    a: "Buka tab My Profile → lengkapi Alamat, Kode Pos, Wilayah, RT/RW, Kelurahan/Desa, dan Kecamatan. Alamat ini dipakai untuk pengiriman sample/produk campaign.",
  },
];

const FaqItem = ({ item, i }) => {
  const [open, setOpen] = useState(i === 0);
  return (
    <div className="rounded-2xl border border-border bg-white overflow-hidden" data-testid={`faq-item-${i}`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left" data-testid={`faq-toggle-${i}`}>
        <span className="font-medium text-showty-navy">{item.q}</span>
        <ChevronDown className={`w-4 h-4 text-showty-red shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-5 pb-4 text-sm text-muted-foreground leading-relaxed" data-testid={`faq-answer-${i}`}>{item.a}</div>}
    </div>
  );
};

export default function HelpPanel() {
  return (
    <div className="space-y-6" data-testid="help-panel">
      <div className="rounded-3xl border border-border bg-gradient-to-r from-showty-pink/50 via-showty-cream to-showty-pink/30 p-7 flex items-start gap-4">
        <div className="w-12 h-12 rounded-2xl bg-showty-red/10 flex items-center justify-center shrink-0"><LifeBuoy className="w-6 h-6 text-showty-red" /></div>
        <div>
          <h2 className="font-display text-2xl text-showty-navy">Pusat Bantuan</h2>
          <p className="mt-1 text-sm text-muted-foreground max-w-xl">Temukan jawaban cepat seputar campaign, point, reward, dan akun kamu. Butuh bantuan lebih lanjut? Hubungi tim Showtynion.</p>
        </div>
      </div>

      <div>
        <h3 className="font-display text-xl text-showty-navy mb-3 flex items-center gap-2"><HelpCircle className="w-5 h-5 text-showty-red" /> Pertanyaan yang Sering Diajukan</h3>
        <div className="space-y-3">
          {FAQS.map((item, i) => <FaqItem key={i} item={item} i={i} />)}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <a href="mailto:secretariatshowty@gmail.com" className="rounded-2xl border border-border bg-white p-5 flex items-center gap-3 hover:bg-showty-cream transition-colors" data-testid="help-email">
          <div className="w-10 h-10 rounded-xl bg-showty-red/10 flex items-center justify-center"><Mail className="w-5 h-5 text-showty-red" /></div>
          <div><p className="font-medium text-showty-navy">Email Support</p><p className="text-xs text-muted-foreground">secretariatshowty@gmail.com</p></div>
        </a>
        <div className="rounded-2xl border border-border bg-white p-5 flex items-center gap-3" data-testid="help-forum">
          <div className="w-10 h-10 rounded-xl bg-showty-navy/10 flex items-center justify-center"><MessageSquare className="w-5 h-5 text-showty-navy" /></div>
          <div><p className="font-medium text-showty-navy">Forum Komunitas</p><p className="text-xs text-muted-foreground">Tanya & berbagi di tab Forum sesuai peran kamu</p></div>
        </div>
      </div>
    </div>
  );
}
